import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LoadScript } from '@react-google-maps/api';
import { LanguageProvider } from './LanguageContext';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import BookingPage from './pages/BookingPage';
import MyBookingsPage from './pages/MyBookingsPage';
import ProfilePage from './pages/ProfilePage';
import OfferPage from './pages/OfferPage';
import ChatPage from './pages/ChatPage';
import TrackingPage from './pages/TrackingPage';
import RatingsPage from './pages/RatingsPage';
import EarningsPage from './pages/EarningsPage';
import NotificationsPage from './pages/NotificationsPage';
import FeedbackPage from './pages/FeedbackPage';
import AdminPage from './pages/AdminPage';
import PaymentPage from './pages/PaymentPage';
import './App.css';
import MessagesPage from './pages/MessagesPage';
import { runAppCleanup } from './cleanupHelper';
import { useEffect } from 'react';

const GOOGLE_MAPS_API_KEY = 'AIzaSyAozleUIU4X-trlC3bEGPp3-F-0HNuJUxE';
const libraries = ['places'];

function App() {
  useEffect(() => {
    runAppCleanup();
  }, []);
  return (
    <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY} libraries={libraries}>
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/my-bookings" element={<MyBookingsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/offer" element={<OfferPage />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/tracking" element={<TrackingPage />} />
            <Route path="/ratings" element={<RatingsPage />} />
            <Route path="/earnings" element={<EarningsPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/feedback" element={<FeedbackPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/messages" element={<MessagesPage />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </LoadScript>
  );
}

export default App;